import moment from 'moment-timezone'
import trackError from './track-error'
import featureToggle from '@/modules/api/featureToggle'

export default {
  getQuote (VueApp, field, leg, quoteData, callback) {
    let self = this
    let booking = VueApp.$store.state.booking
    let airlines = booking.airlines
    let filters = booking.filters
    let isReturning = filters.departure.isReturning
    let locations = booking.locations
    let activeLeg = booking.activeLeg
    let selected = booking.selected
    let settings = booking.settings
    let leg1Discount = settings.groundLeg1
    let leg2Discount = settings.groundLeg2
    let leg3Discount = settings.groundLeg3
    let leg4Discount = settings.groundLeg4

    let usa = ['us', 'usa', 'united states', 'united states of america']
    let canada = ['can', 'ca', 'canada']
    let ca = ['ca', 'california']
    if (
      (quoteData[field].country && usa.indexOf(quoteData[field].country.toLowerCase()) > -1 &&
      quoteData[field].state && ca.indexOf(quoteData[field].state.toLowerCase()) === -1) ||
      (quoteData[field].country && canada.indexOf(quoteData[field].country.toLowerCase()) > -1)
    ) {
      self.getLyftQuote(VueApp, field, leg, quoteData, callback)
      return
    }

    let timeNow = moment()
    VueApp.$sdk.post(VueApp, '/quotation', quoteData, res => {
      self.sendQuoteTime(VueApp, timeNow, moment(), res.quoteId, quoteData)
      try {
        if (!res.error) {
          if (
            quoteData[field].country && usa.indexOf(quoteData[field].country.toLowerCase()) > -1 &&
            (ca.indexOf(quoteData[field].state.toLowerCase()) > -1 && !res.geofences.servicearea.name.includes('LAX'))
          ) {
            self.getLyftQuote(VueApp, field, leg, quoteData, callback)
            return
          }
          let eta = Math.ceil(res.route.eta.sec / 60)
          let services = []
          let pax = filters.travellers.total
          let priceType = isReturning ? 'roundtrip' : 'oneway'
          let isGozocabs = false
          res.services.forEach(service => {
            if (service.serviceType.maxPassengers >= pax) {
              let price = parseFloat(service[priceType][pax - 1].price.toFixed(2))
              if (price < 0) price = 0
              let tip = 0
              if (service.serviceType.defaultTip > 0) {
                tip = price * (service.serviceType.defaultTip / 100)
              }
              if (
                (leg === 'leg1' &&
                  ((field === 'pickup' && leg1Discount.value > 0) ||
                  (field === 'dropoff' && leg2Discount.value > 0))
                ) ||
                (leg === 'leg2' &&
                  ((field === 'pickup' && leg3Discount.value > 0) ||
                  (field === 'dropoff' && leg4Discount.value > 0))
                )
              ) {
                price = parseFloat(service[priceType][pax - 1].original.toFixed(2))
              }
              services.push({
                id: service.serviceType.id,
                name: service.serviceType.name,
                origPrice: parseFloat(service[priceType][pax - 1].original.toFixed(2)),
                price: price,
                rawPrice: parseFloat(service[priceType][pax - 1].price.toFixed(2)),
                discount: parseFloat(service[priceType][pax - 1].discount.toFixed(2)),
                tip: tip,
                pickupFee: 0, // TODO
                airportFee: service.settings.airportFee,
                gasFee: service.settings.gasFee,
                travelInsurance: service.settings.travelInsurance,
                img: service.serviceType.image,
                maxPax: service.serviceType.maxPassengers,
                maxLuggage: service.serviceType.maxLuggages,
                category: service.serviceType.category,
                desc: service.serviceType.descriptionWeb,
                advantage: service.serviceType.advantageWeb,
                portalFee: service.settings.portalFee,
                portalFeeType: service.settings.portalFeeType
              })
            }
          })
          if (!res.services.length && res.gozoCabs && res.gozoCabs.services.length) {
            res.gozoCabs.services.forEach(service => {
              isGozocabs = true
              if (service.cab.seatingCapacity >= pax) {
                // reconvertCurrency passing "INR" - check if gozocabs quote is returning in INR
                services.push({
                  id: service.cab.id,
                  name: service.cab.category,
                  markup: res.gozoCabs.markup.value,
                  pickupTime: res.gozoCabs.pickupTime,
                  pickup: quoteData.pickup,
                  dropoff: quoteData.dropoff,
                  origPrice: self.reconvertCurrency(VueApp, service.fare.totalAmount, 'INR'),
                  price: self.reconvertCurrency(VueApp, service.fare.totalAmount, 'INR'),
                  discount: self.reconvertCurrency(VueApp, service.fare.totalAmount, 'INR'),
                  tip: 0,
                  pickupFee: 0,
                  gasFee: 0,
                  travelInsurance: 0,
                  airportFee: self.reconvertCurrency(VueApp, service.fare.airportEntryFee, 'INR'),
                  gst: self.reconvertCurrency(VueApp, service.fare.gst, 'INR'),
                  stateTax: self.reconvertCurrency(VueApp, service.fare.stateTax, 'INR'),
                  tollTax: self.reconvertCurrency(VueApp, service.fare.tollTax, 'INR'),
                  original: {
                    origPrice: service.fare.totalAmount,
                    price: service.fare.totalAmount,
                    discount: service.fare.totalAmount,
                    airportFee: service.fare.airportEntryFee,
                    gst: service.fare.gst,
                    stateTax: service.fare.stateTax,
                    tollTax: service.fare.tollTax
                  },
                  raw: {
                    cab: service.cab,
                    fare: service.fare
                  },
                  distance: res.route.distance,
                  cancellationPolicy: service.cancellationPolicy
                })
              }
            })
          }

          let categorized = {}
          if (services.length) {
            services.sort((a, b) => a.price - b.price)
            services.forEach(x => {
              if (!categorized[x.category]) categorized[x.category] = []
              categorized[x.category].push(x)
            })
          } else {
            // self.queue = []
            callback(false)
            VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            VueApp.$store.commit('global/setAlertData', {show: true, message: 'We regret to inform you that our current services are unable to meet your specific requirements. We apologize for any inconvenience this may cause and appreciate your understanding.'})
            trackError.track(VueApp, {
              type: 'ground_booking',
              data: {
                main_pickup: locations.pickup,
                main_dropoff: locations.dropoff,
                request: {
                  route: '/quotation',
                  payload: quoteData
                },
                response: res,
                note: 'no service available.'
              }
            })
            return
          }

          let tmpObj = {}
          let tmpName = `${leg}${field === 'dropoff' ? 'Arrive' : 'Depart'}`
          let tmpServiceObj = {
            quoteId: res.quoteId,
            eta: eta,
            distance: res.route.distance,
            Economy: services[0],
            PremiumEconomy: services[0],
            Business: services.length > 1 ? services[1] : services[0],
            // PremiumBusiness: services.length > 1 ? services[1] : services[0],
            First: services.length > 1 ? services[services.length - 1] : services[0],
            list: services,
            pickupGeofence: res.geofences.pickup.id,
            dropoffGeofence: res.geofences.dropoff.id,
            categorized: categorized
          }
          tmpObj[tmpName] = tmpServiceObj
          VueApp.$store.commit('booking/setLandQuote', tmpObj)

          let tmpGround = {}
          // tmpGround[field === 'pickup' ? 'ground1' : 'ground2'] = tmpServiceObj[self.airlines[self.activeLeg].selectedCabin].id
          let selectedCabin = airlines[activeLeg].selectedCabin
          // if (selectedCabin === 'API2' && booking.selectedGround[leg][field] === 'API2') selectedCabin = selected[leg].cabin
          if (selectedCabin === 'API2') selectedCabin = selected[leg].cabin
          tmpGround[field] = tmpServiceObj[selectedCabin].id
          VueApp.$store.commit('booking/updateSelectedGroundData', {
            leg: leg,
            fields: tmpGround
          })

          if (isReturning && leg === 'leg1') {
            let leg1 = selected.leg1
            let leg2 = selected.leg2
            let tmpReturnObj = {}
            let tmpServiceObjClone = JSON.parse(JSON.stringify(tmpServiceObj))

            if (field === 'pickup' && (!settings.customFlight || leg1.flight[0].origin.AirportCode === leg2.flight[leg2.flight.length - 1].destination.AirportCode)) {
              if (leg4Discount.value > 0) {
                tmpServiceObjClone.Economy.price = tmpServiceObjClone.Economy.origPrice
                tmpServiceObjClone.PremiumEconomy.price = tmpServiceObjClone.PremiumEconomy.origPrice
                tmpServiceObjClone.Business.price = tmpServiceObjClone.Business.origPrice
                // tmpServiceObjClone.PremiumBusiness.price = tmpServiceObjClone.PremiumBusiness.origPrice
                tmpServiceObjClone.First.price = tmpServiceObjClone.First.origPrice
              } else {
                tmpServiceObjClone.Economy.price = tmpServiceObjClone.Economy.rawPrice
                tmpServiceObjClone.PremiumEconomy.price = tmpServiceObjClone.PremiumEconomy.rawPrice
                tmpServiceObjClone.Business.price = tmpServiceObjClone.Business.rawPrice
                // tmpServiceObjClone.PremiumBusiness.price = tmpServiceObjClone.PremiumBusiness.rawPrice
                tmpServiceObjClone.First.price = tmpServiceObjClone.First.rawPrice
              }
              tmpReturnObj['leg2Arrive'] = tmpServiceObjClone
              VueApp.$store.commit('booking/setLandQuote', tmpReturnObj)
              VueApp.$store.commit('booking/updateSelectedGroundData', {
                leg: 'leg2',
                fields: {dropoff: tmpServiceObjClone[selectedCabin].id}
              })
            }
            if (field === 'dropoff' && (!settings.customFlight || leg1.flight[leg1.flight.length - 1].destination.AirportCode === leg2.flight[0].origin.AirportCode)) {
              if (leg3Discount.value > 0) {
                tmpServiceObjClone.Economy.price = tmpServiceObjClone.Economy.origPrice
                tmpServiceObjClone.PremiumEconomy.price = tmpServiceObjClone.PremiumEconomy.origPrice
                tmpServiceObjClone.Business.price = tmpServiceObjClone.Business.origPrice
                // tmpServiceObjClone.PremiumBusiness.price = tmpServiceObjClone.PremiumBusiness.origPrice
                tmpServiceObjClone.First.price = tmpServiceObjClone.First.origPrice
              } else {
                tmpServiceObjClone.Economy.price = tmpServiceObjClone.Economy.rawPrice
                tmpServiceObjClone.PremiumEconomy.price = tmpServiceObjClone.PremiumEconomy.rawPrice
                tmpServiceObjClone.Business.price = tmpServiceObjClone.Business.rawPrice
                // tmpServiceObjClone.PremiumBusiness.price = tmpServiceObjClone.PremiumBusiness.rawPrice
                tmpServiceObjClone.First.price = tmpServiceObjClone.First.rawPrice
              }
              tmpReturnObj['leg2Depart'] = tmpServiceObjClone
              VueApp.$store.commit('booking/setLandQuote', tmpReturnObj)
              VueApp.$store.commit('booking/updateSelectedGroundData', {
                leg: 'leg2',
                fields: {pickup: tmpServiceObjClone[selectedCabin].id}
              })
            }
          }

          let tmpGozo = {}
          tmpGozo[tmpName] = isGozocabs
          VueApp.$store.commit('booking/setGozoCabsData', tmpGozo)
        } else {
          if (
            (quoteData.pickup.country && usa.indexOf(quoteData.pickup.country.toLowerCase()) > -1) ||
            (quoteData.pickup.country && canada.indexOf(quoteData.pickup.country.toLowerCase()) > -1)
          ) {
            self.getLyftQuote(VueApp, field, leg, quoteData, callback)
            return
          }
          VueApp.$store.commit('booking/setSelectedData', {leg1: {}, leg2: {}})
          VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          VueApp.$store.commit('global/setAlertData', {show: true, message: res.error.message})
          trackError.track(VueApp, {
            type: 'ground_booking',
            data: {
              main_pickup: locations.pickup,
              main_dropoff: locations.dropoff,
              request: {
                route: '/quotation',
                payload: quoteData
              },
              response: res
            }
          })
          return
        }
        callback(true)
        // self.queue.shift()
        // self.processQueue()
      } catch (error) {
        console.log('quotation error:', error)
        VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        VueApp.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please try again.'})
        trackError.track(VueApp, {
          type: 'ground_booking',
          data: {
            main_pickup: locations.pickup,
            main_dropoff: locations.dropoff,
            request: {
              route: '/quotation',
              payload: quoteData
            },
            response: '',
            console_error: error
          }
        })
      }
    }, '2.0')
  },

  getLyftQuote (VueApp, field, leg, quoteData, callback) {
    let self = this
    let booking = VueApp.$store.state.booking
    let airlines = booking.airlines
    let filters = booking.filters
    let isReturning = filters.departure.isReturning
    let locations = booking.locations
    let activeLeg = booking.activeLeg
    let selected = booking.selected
    // let settings = booking.settings
    // let leg1Discount = settings.groundLeg1
    // let leg2Discount = settings.groundLeg2
    // let leg3Discount = settings.groundLeg3
    // let leg4Discount = settings.groundLeg4

    let newParam = {
      brandId: quoteData.brandId,
      pickup: quoteData.pickup,
      dropoff: quoteData.dropoff,
      // pickupTime: moment(rsvpLeg.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(VueApp, false)).format('X'),
      leg: quoteData.leg
    }
    if (leg === 'leg2') {
      let pickup = JSON.parse(JSON.stringify(newParam.pickup))
      let dropoff = JSON.parse(JSON.stringify(newParam.dropoff))
      newParam.pickup = dropoff
      newParam.dropoff = pickup
    }
    let pickupDate = booking.filters.departure.date
    let flightType = leg === 'leg1' ? 'flight' : 'returnFlight'
    if (field === 'pickup') {
      pickupDate = booking.selected.leg1[flightType][0].origin.DateTime
      // pickupDate = pickupDate.split(' ')[0]
    } else {
      pickupDate = booking.selected.leg1[flightType][booking.selected.leg1[flightType].length - 1].destination.DateTime
      // pickupDate = pickupDate.split(' ')[0]
    }
    newParam.pickupTime = moment(pickupDate, 'YYYY-MM-DD ' + featureToggle.timeFormat(VueApp, false)).format('X')

    let tmpQuoteType = {}
    tmpQuoteType[`${leg}${field === 'dropoff' ? 'Arrive' : 'Depart'}`] = 'rsp'
    VueApp.$store.commit('booking/setLandQuoteType', tmpQuoteType)

    VueApp.$sdk.post(VueApp, '/quotation/lyft/future', newParam, res => {
      if (res.lyft) {
        let hasService = false
        res.lyft.forEach(x => {
          if (x.can_request_ride) hasService = true
        })
        if (!hasService) res.lyft = []
      }
      if (res.lyft && res.lyft.length) {
        let tmpQuoteType = {}
        tmpQuoteType[`${leg}${field === 'dropoff' ? 'Arrive' : 'Depart'}`] = 'lyft'
        VueApp.$store.commit('booking/setLandQuoteType', tmpQuoteType)

        let eta = Math.ceil(res.route.eta.sec / 60)
        let services = []
        res.lyft.forEach(x => {
          let price = (x.estimated_cost_cents_max / 100).toFixed(2)
          // if (x.display_name === 'Lyft') x.display_name = 'Prime Time Express'
          let maxPax = x.price_explanation_text ? x.price_explanation_text.replace(/^\D+/g, '') : 4
          if (maxPax) maxPax = parseInt(maxPax)
          if (!maxPax) maxPax = 4
          services.push({
            id: x.ride_type,
            code: 'a' + x.ride_type,
            name: x.display_name,
            origPrice: parseFloat(price),
            price: parseFloat(price),
            rawPrice: parseFloat(price),
            discount: parseFloat(price),
            tip: 0,
            pickupFee: 0,
            airportFee: 0,
            gasFee: 0,
            travelInsurance: 0,
            img: x.custom_image,
            maxPax: maxPax,
            maxLuggage: maxPax,
            category: 'Select a Ride',
            desc: '',
            advantage: '',
            ride_type: x.ride_type,
            cost_token: x.cost_token,
            driver_availability_token: x.driver_availability_token || ''
          })
        })

        let categorized = {}
        if (services.length) {
          services.sort((a, b) => a.price - b.price)
          services.forEach(x => {
            if (!categorized[x.category]) categorized[x.category] = []
            categorized[x.category].push(x)
          })
        } else {
          callback(false)
          VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          VueApp.$store.commit('global/setAlertData', {show: true, message: 'We regret to inform you that our current services are unable to meet your specific requirements. We apologize for any inconvenience this may cause and appreciate your understanding.'})
          trackError.track(VueApp, {
            type: 'ground_booking',
            data: {
              main_pickup: locations.pickup,
              main_dropoff: locations.dropoff,
              request: {
                route: '/quotation',
                payload: quoteData
              },
              response: res,
              note: 'no service available.'
            }
          })
          return
        }

        let tmpObj = {}
        let tmpName = `${leg}${field === 'dropoff' ? 'Arrive' : 'Depart'}`
        let tmpServiceObj = {
          quoteId: res.quoteId,
          eta: eta,
          distance: res.route.distance,
          Economy: services[0],
          PremiumEconomy: services[0],
          Business: services.length > 1 ? services[1] : services[0],
          // PremiumBusiness: services.length > 1 ? services[1] : services[0],
          First: services.length > 1 ? services[services.length - 1] : services[0],
          list: services,
          pickupGeofence: 0,
          dropoffGeofence: 0,
          categorized: categorized
        }
        tmpObj[tmpName] = tmpServiceObj
        VueApp.$store.commit('booking/setLandQuote', tmpObj)

        let tmpGround = {}
        let selectedCabin = airlines[activeLeg].selectedCabin
        if (selectedCabin === 'API2') selectedCabin = selected.leg1.cabin
        tmpGround[field] = tmpServiceObj[selectedCabin].id
        VueApp.$store.commit('booking/updateSelectedGroundData', {
          leg: leg,
          fields: tmpGround
        })

        if (isReturning && leg === 'leg1') {
          self.getLyftQuote(VueApp, field === 'pickup' ? 'dropoff' : 'pickup', 'leg2', quoteData, callback)
          return
        }
        callback(true)
      } else {
        VueApp.$store.commit('booking/setSelectedData', {leg1: {}, leg2: {}})
        VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        VueApp.$store.commit('global/setAlertData', {show: true, message: VueApp.$t('searchForm.noAvailableService')})
        trackError.track(VueApp, {
          type: 'ground_booking',
          data: {
            main_pickup: locations.pickup,
            main_dropoff: locations.dropoff,
            request: {
              route: '/quotation/lyft/future',
              payload: newParam
            },
            response: res
          }
        })
        return
      }
    }, '2.0')
  },

  sendQuoteTime (VueApp, start, end, quoteId, param) {
    let store = VueApp.$store.state
    let duration = end.diff(start, 'milliseconds') / 1000
    VueApp.$sdk.opt('/quotation/time', {
      token: store.user.token,
      brandId: store.brandId,
      quotationId: quoteId,
      responseTime: duration,
      deviceType: 'ww',
      data: JSON.stringify(param)
    }, res => {
      if (res.error) console.log('ERROR quotation time')
    })
  },

  reconvertCurrency (VueApp, x, code) {
    let other = VueApp.$store.state.other
    let currency = other.currency
    let currRate = currency.list[code]
    x = parseFloat(x.toFixed(2))
    x = parseFloat((x / currRate).toFixed(2))
    return x
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/flight-ground-quote.js